import { render } from "./commentForm.vue?vue&type=template&id=1be138c0&scoped=true"
import script from "./commentForm.vue?vue&type=script&lang=js"
export * from "./commentForm.vue?vue&type=script&lang=js"

import "./commentForm.vue?vue&type=style&index=0&id=1be138c0&lang=css&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be138c0"]])

export default __exports__